import axios from 'axios'
import { url } from './global'

/**
 * Listados scope tenant (ROLE_ADMIN_MAGENTA). Query param: tenant.
 */
export const getAllBackofficeSucursales = async (
    tenantId,
    activo,
    page,
    nombre,
    size = 50
) => {
    const token = sessionStorage.getItem('token')
    const headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    const t = `tenant=${encodeURIComponent(tenantId)}&`
    const res = await axios.get(
        `${url}/v2/backoffice/sucursales?${t}${nombre ? `nombre=${nombre}&` : ''}activo=${activo}&page=${page}&size=${size}`,
        { headers }
    )
    return res
}

export const getAllBackofficePuntoVentas = async (
    tenantId,
    sucursal,
    activo,
    page,
    nombre,
    size = 50
) => {
    const token = sessionStorage.getItem('token')
    const headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    const t = `tenant=${encodeURIComponent(tenantId)}&`
    const res = await axios.get(
        `${url}/v2/backoffice/punto-ventas?${t}${sucursal ? `sucursal=${sucursal}&` : ''}${nombre ? `nombre=${nombre}&` : ''}activo=${activo}&page=${page}&size=${size}`,
        { headers }
    )
    return res
}

export const getAllBackofficeDatoFiscales = async (
    tenantId,
    activo,
    page,
    razonSocial,
    size = 50
) => {
    const token = sessionStorage.getItem('token')
    const headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    const t = `tenant=${encodeURIComponent(tenantId)}&`
    const res = await axios.get(
        `${url}/v2/backoffice/dato-fiscales?${t}${razonSocial ? `razonSocial=${razonSocial}&` : ''}activo=${activo}&page=${page}&size=${size}`,
        { headers }
    )
    return res
}
